import { LoggerLoggingLevelEnum } from '../app/services/logger/logger.service';

export const environment = {
  production: true,
  loggerLevel: LoggerLoggingLevelEnum.All,
  vuUrl: 'https://v21.maxcrc.de',
  odooUrl: 'https://koenigsbrunn.maxcrc.de',
  odooDatabaseName: 'koenigsbrunn',
  odooPaymentControllerUrl: '/payment-v21/kiosk-order',
  globalSettings: null,
  contactFormUrl: '/contact',
  linkLocationCSS: 'static/theme/konigsbrunn/css/konigsbrunn_style.css',
  theme: '',
  srcVideo: '',
  availableLangs: ['de-DE'],
  internalEventInfoLink: '',
  useVirtualKeyboard: true,
  title: 'Koenigsbrunn Web Shop',
  faviconUrl: '/konigsbrunn/static/src/img/favicon.ico',
  smartCardUrl: '',
  shopMode: '',
};
